import { render, staticRenderFns } from "./inputStorageInfo.vue?vue&type=template&id=6a35bb63&scoped=true&"
import script from "./inputStorageInfo.vue?vue&type=script&lang=js&"
export * from "./inputStorageInfo.vue?vue&type=script&lang=js&"
import style0 from "./inputStorageInfo.vue?vue&type=style&index=0&id=6a35bb63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35bb63",
  null
  
)

export default component.exports